import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {FloatingButtonAction} from '@share/component/floating-button/floating-button';

/**
 * Service de gestion des contrats
 *
 * @author Yannick Gauthier
 * @date 18/08/2025
 */
@Injectable()
export class ContratButtonService {
    /** Actions du floating button */
    private actions = new BehaviorSubject<Array<FloatingButtonAction>>([]);
    
    /** Fonction de retour personnalisée */
    private customGoBackFunction: Function = null;

    /**
     * Définit les actions du floating button
     *
     * @param actions Liste des actions
     */
    setActions(actions: Array<FloatingButtonAction>): void {
        this.actions.next(actions);
    }

    /**
     * Récupère les actions du floating button
     *
     * @returns Observable des actions
     */
    getActions(): Observable<Array<FloatingButtonAction>> {
        return this.actions.asObservable();
    }

    /**
     * Définit une fonction de retour personnalisée
     * 
     * @param goBackFunction Fonction de retour personnalisée
     */
    setCustomGoBackFunction(goBackFunction: Function): void {
        this.customGoBackFunction = goBackFunction;
    }
    
    /**
     * Exécute la fonction de retour personnalisée si elle existe, sinon retourne null
     * 
     * @returns true si une fonction personnalisée a été exécutée, false sinon
     */
    executeCustomGoBackFunction(): boolean {
        if (this.customGoBackFunction) {
            this.customGoBackFunction();
            return true;
        }
        return false;
    }
    
    /**
     * Réinitialise la fonction de retour personnalisée
     */
    resetCustomGoBackFunction(): void {
        this.customGoBackFunction = null;
    }
}
